/** The close-out workspace gives each tab its own route, `/close-out/<tab>` (`recordTabRoutes`): the open gaps first. */
export const CLOSE_OUT_TABS = ['gaps', 'resolved', 'all'] as const;
export type CloseOutTab = (typeof CLOSE_OUT_TABS)[number];

export const CLOSE_OUT_TAB_LABELS: Record<CloseOutTab, string> = { gaps: 'Open gaps', resolved: 'Resolved', all: 'All closed-out trips' };

export const CLOSE_OUT_PATH = '/close-out';

export function closeOutTabPath(tab: CloseOutTab): string {
  return `${CLOSE_OUT_PATH}/${tab}`;
}

/** A trip's comparison, with every source behind it: a record, so it lives under the workspace and not under a tab. */
export function closeOutTripPath(tripId: string): string {
  return `${CLOSE_OUT_PATH}/trips/${tripId}`;
}

/** Every closed-out trip of one truck, for the link from the truck's record. */
export function closeOutTruckPath(truckId: string): string {
  return `${closeOutTabPath('all')}?truckId=${truckId}`;
}
